import { motion } from "framer-motion";
import { TypingText } from "../components";

import styles from '../styles';
import { fadeIn, staggerContainer } from '../utils/motion'

const About = () => (
  <section className={`${styles.paddings} relative z-10`} id='about'>
    <div className="gradient-02 z-0" />
    <motion.div
      variants={staggerContainer}
      initial='hidden'
      whileInView='show'
      viewport={{ once: false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto ${styles.flexCenter} flex-col`}
    >
      <TypingText title='| About' textStyles='text-center'/>
      <motion.p 
        variants={fadeIn('up', 'tween', 0.2, 1)}
        className='mt-[8px] font-normal sm:text-[32px] text-[20px] text-center text-secondary-white'
      >
        <span className="font-extrabold text-white">Genshin Impact </span>  is a popular action role-playing video game developed by Chinese game developer {' '}
        <span className="font-extrabold text-white">
        miHoYo
        </span>{' '}
        . The game is set in the fictional world of {' '}
        <span className="font-extrabold text-white">Teyvat</span> , where the player explores and completes quests in a vast open world filled with magical creatures, ancient ruins, and diverse cultures. The game also features a gacha system for obtaining new characters and weapons, and a multiplayer co-op mode. Genshin Impact has gained widespread popularity for its stunning graphics, immersive gameplay, and engaging storyline.
      </motion.p>
      <motion.img
        variants={fadeIn('up', 'tween', 0.3, 1)}
        src='/arrow-down.svg'
        alt='arrow down'
        className="w-[14px] h-[28px] object-contain mt-[28px]"
      />
    </motion.div>
  </section>
);

export default About;
